/**
 * Configuration constants for the paginated app grid
 */
export const GRID_CONFIG = {
  /** Number of featured apps to show before the Atlassian apps section */
  FEATURED_APPS_COUNT: 3,
  /** Number of Atlassian app tiles to show */
  ATLASSIAN_APP_TILES_COUNT: 9,
  /** Number of skeleton tiles to show during initial load (multiplier of desktop columns) */
  INITIAL_SKELETON_TILE_MULTIPLIER: 6,
  /** Number of skeleton tiles to show when loading more (multiplier of columns) */
  LOAD_MORE_SKELETON_TILE_MULTIPLIER: 2
};